import { createContext, Context } from 'react';
import { GlobalState, GlobalDispatch, GlobalDispatchArgs } from '../components/app/AppWrapper';
export const GlobalContext: Context<[GlobalState, GlobalDispatch]> = createContext(null);

export const useCombinedReducer = (
  useReducers: Record<string, any[]>
): [GlobalState, GlobalDispatch] => {
  // Global state
  const _state = Object.keys(useReducers).reduce(
    (acc, key) => ({ ...acc, [key]: useReducers[key][0] }),
    {}
  );
  const state = (_state as unknown) as GlobalState;

  // Global dispatch function
  const dispatch: GlobalDispatch = (action: GlobalDispatchArgs) => {
    Object.keys(useReducers)
      .map(key => useReducers[key][1])
      .forEach(fn => fn(action));
  };

  // console.log('useCombinedReducer: state', state);
  return [state, dispatch];
};

export default useCombinedReducer;
